// extracted by mini-css-extract-plugin
export var blink = "_93-2";
export var cursor = "_93-1";
export var reactMarkdown = "_93-3";
export var streamingText = "_93-0";